/* unplugin-vue-components disabled */import "core-js/modules/es.array.map.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import ExtField from '@/components/ExtField';
export default {
  inheritAttrs: false,
  components: {
    ViewBox: ViewBox,
    Previewer: Previewer,
    ExtField: ExtField
  },
  directives: {
    // 指令
    TransferDom: TransferDom
  },
  props: {
    orderInfo: {
      type: Object,
      required: true
    },
    orderExtFields: {
      type: Array,
      required: true
    },
    remarkPicList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    template: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          if (thumbnail) {
            var _thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        }
      }
    };
  },
  computed: {
    remarkPicListForPreviewer: function remarkPicListForPreviewer() {
      return this.remarkPicList.map(function (item) {
        return {
          src: item.img_url
        };
      });
    }
  },
  methods: {
    show: function show(index) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs['previewer'].show(index);
      });
    }
  }
};